import React from 'react';
import { faListOl } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createBlockStyleButton } from 'draft-js-buttons';

export default createBlockStyleButton({
    blockType: 'ordered-list-item',
    children: (
        <FontAwesomeIcon icon={faListOl} />
    )
});